import axios from "axios";

//const API_URL = 'https://agifs.credisolve.co.za/api/';
//const API_URL = 'https://branch.credisolve.co.za/api/';
const API_URL = 'https://mmh.credisolve.co.za/api/';
//const API_URL = 'http://localhost:50463/';
axios.defaults.baseURL = API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.interceptors.response.use(
    (a) => a,
    (error) => {
        if (!error.response) return Promise.reject({response: {data: 'Network Error'}});
        return Promise.reject(error);
    }
);


const CONTROLLER_PATH = "Experian";

class ExperianService {
    getContactNumbers(urlParameters) {
        return axios.get(CONTROLLER_PATH + "/getContactNumbers/", {params: urlParameters}).then((response) => response.data);
    }

    submitContactNumber(urlParameters) {
        return axios.get(CONTROLLER_PATH + "/submitContactNumber/", {params: urlParameters}).then((response) => response.data);
    }

    confirmOtp(urlParameters) {
        return axios.get(CONTROLLER_PATH + "/confirmOtp/", {params: urlParameters}).then((response) => response.data);
    }

    getDepartments() {
        return axios.get(CONTROLLER_PATH + "/getDepartments").then((response) => response.data);
    }

    getCommunicationOptions() {
        return axios.get(CONTROLLER_PATH + "/getCommunicationOptions").then((response) => response.data);
    }

    credisolveSubmit(formData) {
        return axios
            .post(CONTROLLER_PATH + "/credisolveSubmit", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }

    arrangeCallSubmit(urlParameters) {
        return axios.get(CONTROLLER_PATH + "/arrangeCallSubmit", {params: urlParameters}).then((response) => response.data);
    }

    getPersonScore(urlParameters){
        return axios.get(CONTROLLER_PATH + "/getPersonScore/", {params: urlParameters}).then((response) => response.data);
    }

    getDebtRestructuring(urlParameters){
        return axios.get(CONTROLLER_PATH + "/DoNormalSearchEnquiry/", {params: urlParameters}).then((response) => response.data);
    }
}

export default new ExperianService();
